import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';

import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

import { ConfirmDialogComponent } from './confirm-dialog.component';
import { ConfirmDialogService } from './confirm-dialog.service';

@NgModule({
	declarations: [
		ConfirmDialogComponent
	],
	entryComponents: [
		ConfirmDialogComponent
	],
	imports: [
		CommonModule,
		FlexLayoutModule,
		MatButtonModule,
		MatDialogModule
	],
	providers: [
		ConfirmDialogService
	],
	exports: [
		ConfirmDialogComponent
	]
})
class ConfirmDialogModule {}

export {
	ConfirmDialogModule,
	ConfirmDialogService
};
